import { Observable, of } from 'rxjs';
import { filter, map, tap, switchMap } from 'rxjs/operators';
import { sortArrayBy, sortArrayById } from './entity.helpers';
import { BaseEntity } from '../models';

export type BaseResponse = { data: any };
export type Diff<T, U> = T extends U ? never : T;

export const filterNil = <T>(source: Observable<T | undefined | null>) =>
  source.pipe(filter((value): value is Diff<T, null | undefined> => value !== null && typeof value !== 'undefined'));

export const filterNilData = <T extends BaseResponse>(source: Observable<T | undefined | null>) =>
  source.pipe(filter(response => !!response.data));

export const sortByKey = <T>(key: keyof T) => (source: Observable<T[]>) => source.pipe(map(data => sortArrayBy<T>(data, key)));

export const sortById = <T extends BaseEntity>() => (source: Observable<T[]>) => source.pipe(map(data => sortArrayById<T>(data)));

export function startWithTap<T>(callback: () => void) {
  return (source: Observable<T>) =>
    of({}).pipe(
      tap(callback),
      switchMap(() => source)
    );
}
